import { IDropdownConfig } from '@app/shared/models/dropdown.model'

/**
 * Build page size dropdown configuration.
 */
export function buildPageSizeConfig(
    pageSizeOptions: readonly number[],
    pageSizeLabel: string,
): IDropdownConfig {
    return {
        label: pageSizeLabel,
        placeholder: pageSizeLabel,
        options: pageSizeOptions.map((size) => ({
            id: size,
            value: size,
            label: size.toString(),
        })),
        enableSearch: false,
    }
}
